<template>
  <div class="container shop">
    <follow @follow="followFn"></follow>
    <div class="header" :style="follow ? { top: '0.5rem' } : { top: '0' }">
      <div class="tit">创客云商发货</div>
      <div
        :class="{ edit: true, active: goodsDelShow }"
        v-if="list && list.length > 0"
        @click="changeEdit"
      >
        {{ goodsDelShow ? '完成' : '编辑' }}
      </div>
      <div class="kefu" @click="keFu">
        <img src="../../assets/images/service.png" />
      </div>
    </div>
    <div id="cup" :style="follow ? { 'margin-top': '0.95rem' } : { 'margin-top': '0.44rem' }">
      <Scroller
        v-if="!nodata"
        :is-refresh-data.sync="refresh"
        :is-loading-data.sync="loading"
        :is-finished-data.sync="finished"
        :no-data-text-data.sync="noDataText"
        @on-infinite="onInfinite"
        @on-refresh="onRefresh"
        class="my_scroller"
        ref="my_scroller"
      >
        <div class="skinTest" style="margin-top: 0.05rem; margin-bottom: 0.1rem" v-if="advertis">
          <advertisingSpace></advertisingSpace>
        </div>
        <act-coupon></act-coupon>
        <div
          class="couponmsg flex-js-ac"
          v-if="topmsg && (topmsg.type == 2 || topmsg.type == 3)"
          style="width: 100%"
          @click="$router.push('/cashcoupon' + (topmsg.type == 3 ? '?navIndex=1' : ''))"
        >
          <div class="flex-ac">
            <div class="couponImg">
              <img
                class="flex-1"
                :src="topmsg.type == 3 ? topmsg.img_path : '/static/images/coupon@2x.png'"
              />
              <span v-if="topmsg.type == 2" class="f13 color-FC0324">{{ topmsg.couponmoney }}</span>
            </div>
            <div>
              <p class="f13" style="color: #333333; font-weight: bold; margin-bottom: 0.03rem">
                {{ topmsg.message1 }}
              </p>
              <p class="f12" style="color: #6c6c6c">{{ topmsg.message2 }}</p>
            </div>
          </div>
          <div class="f13 flex-ac color-FC0324">
            卡券包
            <van-icon name="arrow" color="#FC0324" />
          </div>
        </div>
        <div class="cart_list" v-if="list && list.length > 0">
          <van-sticky :offset-top="0" @change="fixedFn">
            <div
              class="additemMsg fullsubtract"
              :style="fixedStyle"
              v-if="fullMinusRules.actStatus != -1"
              @click="gofullsubtract"
            >
              <div class="msg">
                <div
                  class="txt flex"
                  v-if="fullMinusRules.actStatus == 0 && fullMinusRules.actDesc"
                >
                  <van-tag
                    class="flex-s"
                    color="linear-gradient(to right, #FE074A, #F63A66)"
                    text-color="#ffffff"
                  >
                    {{ fullMinusRules.actName }}
                  </van-tag>
                  <b>{{ fullMinusRules.actDesc }}</b>
                </div>
                <div class="txt flex" v-else>
                  <van-tag
                    class="flex-s"
                    color="linear-gradient(to right, #FE074A, #F63A66)"
                    text-color="#ffffff"
                  >
                    {{ fullMinusRules.actName }}
                  </van-tag>
                  <b v-html="fullMinusMsg"></b>
                </div>
              </div>
              <div class="btn" v-if="fullMinusRules.actStatus != -1">凑单></div>
            </div>
          </van-sticky>
          <div
            :class="{ cart_item: true, soldoutx: item.inventory == 0 || item.is_can_buy == 0 }"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="product_list">
              <div v-if="item.isdeposit == 1">
                <van-checkbox
                  :disabled="
                    item.finalpaystatus == 0 ||
                    item.inventory == 0 ||
                    item.islimit != 0 ||
                    item.is_can_buy == 0 ||
                    parseInt(item.canbuycnt) <= 0
                  "
                  @change="checkedSingle(item)"
                  @click="checkedSingleFn(item)"
                  checked-color="#FC0324"
                  v-if="!goodsDelShow"
                  v-model="item.ischoose"
                ></van-checkbox>
                <van-checkbox
                  :disabled="item.isdeposit == 1"
                  @change="checkedSingle(item)"
                  @click="checkedSingleFn(item)"
                  checked-color="#FC0324"
                  v-if="goodsDelShow"
                  v-model="item.ischoose"
                ></van-checkbox>
              </div>
              <div v-else>
                <van-checkbox
                  v-if="!goodsDelShow"
                  v-model="item.ischoose"
                  checked-color="#FC0324"
                  @change="checkedSingle(item)"
                  @click="checkedSingleFn(item)"
                  :disabled="
                    item.inventory == 0 ||
                    item.islimit != 0 ||
                    item.is_can_buy == 0 ||
                    parseInt(item.canbuycnt) <= 0 ||
                    item.issale == 0
                  "
                ></van-checkbox>
                <van-checkbox
                  v-if="goodsDelShow"
                  v-model="item.ischoose"
                  checked-color="#FC0324"
                  @change="checkedSingle(item)"
                  @click="checkedSingleFn(item)"
                ></van-checkbox>
              </div>
              <div class="proitem">
                <div class="proimgx">
                  <img v-lazy="item.img_path" class="proimg" @click="productFn(item)" />
                  <img
                    src="../../assets/images/soldout.png"
                    @click="productFn(item)"
                    class="soldout"
                    v-if="item.inventory == 0 && item.issale == 0 && item.is_can_buy != 0"
                  />
                  <img
                    src="../../assets/images/daishou.png"
                    @click="productFn(item)"
                    class="soldout"
                    v-if="
                      item.isdeposit == 0 &&
                      item.inventory == 1 &&
                      item.islimit == 1 &&
                      item.canbuycnt > 0 &&
                      item.issale == 1 &&
                      item.is_can_buy != 0
                    "
                  />
                  <img
                    @click="productFn(item)"
                    class="soldout"
                    src="../../assets/images/daishou.png"
                    v-if="
                      item.isdeposit == 1 &&
                      item.inventory == 1 &&
                      item.islimit == 1 &&
                      item.canbuycnt > 0 &&
                      item.is_can_buy != 0
                    "
                  />
                  <img
                    @click="productFn(item)"
                    class="soldout"
                    src="/static/images/shouqing.png"
                    v-if="
                      item.inventory == 0 &&
                      item.islimit == 2 &&
                      item.canbuycnt > 0 &&
                      item.is_can_buy != 0
                    "
                  />
                </div>
                <div class="goods_info">
                  <div @click="productFn(item)" class="goods_tit flex">
                    <div>
                      <label v-if="item.name.length < 26">{{ item.name }}</label>
                      <label v-if="item.name.length >= 26">{{ item.name.slice(0, 26) }}...</label>
                      <img src="../../assets/images/overseas.png" v-if="item.isoversea == 1" />
                    </div>
                    <label v-if="item.isdeposit == 1">x{{ item.num }}</label>
                  </div>
                  <!--style="margin-bottom: 0.07rem"-->
                  <div class="goods_spec" v-if="item.isdeposit == 1">
                    <div class="dspec" style="background: transparent">{{ item.spec }}</div>
                  </div>
                  <div class="goods_spec" v-else>
                    <div
                      class="dspec again"
                      v-if="item.inventory == 1 && (item.islimit == 2 || item.issale == 0)"
                      @click="openSku(item, index)"
                    >
                      重选
                      <van-icon name="arrow-down" color="#FE5E00" />
                    </div>
                    <div class="dspec" v-else @click="openSku(item, index)">
                      {{ item.spec }}
                      <van-icon name="arrow-down" />
                    </div>
                  </div>
                  <div
                    style="
                      font-size: 0.11rem;
                      font-weight: 400;
                      color: rgba(254, 94, 0, 1);
                      line-height: 0.16rem;
                      padding: 0.05rem 0;
                    "
                    v-if="
                      parseInt(item.canbuycnt) <= parseInt(item.lib_warning) &&
                      parseInt(item.canbuycnt) > 0 &&
                      item.islimit == 0 &&
                      item.issale == 1
                    "
                  >
                    <p>库存紧张</p>
                  </div>
                  <div class="PriceAndNum pos-r">
                    <div class="goods_price">
                      <span
                        class="smallprice ws-n"
                        :class="[
                          item.isDirectReduction == 1 ||
                          item.fullDiscountPrice ||
                          item.birthdayDiscountPrice
                            ? 'grayPrice'
                            : ''
                        ]"
                        v-if="
                          (item.canbuycnt > 0 && item.islimit != 2 && item.issale == 1) ||
                          item.inventory == 0
                        "
                        :style="
                          item.isDirectReduction != 1 ||
                          item.fullDiscountPrice ||
                          item.birthdayDiscountPrice
                            ? { 'font-size': 0 }
                            : {}
                        "
                      >
                        <sub>{{ (item.isdeposit == 1 ? '尾款' : '') + '¥' }}</sub>
                        <b>{{ cartHeadText(item).slice(0, cartHeadText(item).indexOf('.')) }}</b>
                        <sup>{{ cartHeadText(item).slice(cartHeadText(item).indexOf('.')) }}</sup>
                      </span>
                      <span
                        v-if="
                          item.isDirectReduction == 1 ||
                          item.fullDiscountPrice ||
                          item.birthdayDiscountPrice
                        "
                        class="smallprice ws-n"
                      >
                        <sub>
                          {{
                            item.isDirectReduction == 1
                              ? '到手价¥'
                              : (item.fullDiscountPrice &&
                                  item.birthdayDiscountPrice &&
                                  item.fullDiscountPrice > item.birthdayDiscountPrice) ||
                                !item.birthdayDiscountPrice
                              ? '限时折后单价¥'
                              : '生日折后单价¥'
                          }}
                        </sub>
                        <b>{{ cartSaleText(item).slice(0, cartSaleText(item).indexOf('.')) }}</b>
                        <sup>{{ cartSaleText(item).slice(cartSaleText(item).indexOf('.')) }}</sup>
                      </span>
                      <p
                        v-if="
                          item.isdeposit == 0 &&
                          item.inventory == 1 &&
                          (item.canbuycnt <= 0 || item.islimit == 2 || item.issale == 0)
                        "
                        style="width: 100%; color: #333; font-size: 0.12rem"
                      >
                        已售磬，请重新选择商品规格
                      </p>
                    </div>
                    <van-stepper
                      @blur="num(item)"
                      :long-press="false"
                      integer
                      @change="stepperFn(item)"
                      @minus="num(item)"
                      @plus="num(item)"
                      class="goods_stepper ws-n pos-a r0"
                      v-if="
                        item.islimit == 0 &&
                        parseInt(item.canbuycnt) > 0 &&
                        item.issale != 0 &&
                        item.is_can_buy != 0 &&
                        !item.isdeposit
                      "
                      v-model="item.num"
                      @overlimit="overlimit(item)"
                      :min="1"
                      :max="parseInt(item.canbuycnt)"
                    />
                  </div>
                  <div
                    class="f0 tag flex-ac"
                    v-if="item.fullMonusRules && item.fullMonusRules.actLabel"
                  >
                    <van-tag class="tag_danger" type="danger">
                      {{ item.fullMonusRules.actLabel }}
                    </van-tag>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="act_desc_tag"
              v-if="
                parseInt(item.ispresale) == 1 ||
                parseInt(item.isdiscount) == 1 ||
                parseInt(item.isfullgift) == 1 ||
                (parseInt(halfprice.halfpricestatus) == 1 && item.ishalf == 1) ||
                parseInt(item.isFullDiscount) == 1 ||
                parseInt(item.ismorediscounts) == 1
              "
              @click="showActDesc(item)"
            >
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.ispresale) == 1">
                预售
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.isdiscount) == 1">
                {{ discountrule.actlabel }}
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.isfullgift) == 1">
                {{ fullgiftrule.actlabel ? fullgiftrule.actlabel : '满赠' }}
              </van-tag>
              <van-tag
                color="#FEE9E6"
                text-color="#F12A0E"
                v-if="parseInt(halfprice.halfpricestatus) == 1 && item.ishalf == 1"
              >
                {{ halfprice.halfactlabel }}
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="item.isFullDiscount">
                限时折扣
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="item.ismorediscounts == 1">
                {{ item.morediscountslabel }}
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="item.isbuygift == 1">
                买赠
              </van-tag>
              <van-icon name="arrow" />
            </div>
            <div class="act_desc_time" v-if="parseInt(item.ispresale) == 1">
              <img src="../../assets/images/presell.png" />
              <div class="txt">预售发货时间：{{ item.presaletime }}</div>
            </div>
            <div class="act_desc_time" v-if="item.isdeposit == 1">
              <img src="../../assets/images/presell.png" />
              <div class="txt" v-if="item.finalpaystatus == 0">
                {{ dateFn(item.finalpaymenttime, 'datetimestr') }}开始支付尾款
              </div>
              <div class="txt" v-if="item.finalpaystatus == 1">
                {{ dateFn(item.finalpaymenttime, 'datetimestr') }}截止支付尾款
              </div>
            </div>
            <div class="act_desc" v-if="item.rulelist">【秒杀】秒杀活动开始时间还剩 08:12:00</div>
          </div>
        </div>
        <div
          style="margin-top: 0.1rem; padding: 0.15rem 0.11rem 0.71rem; background: #fff"
          v-if="list && list.length > 0 && productlist && productlist.length > 0 && recommend"
          :skuSwitch="'1'"
        >
          <product-list
            :title="title"
            :productlist="productlist"
            :skuSwitch="'1'"
            @addCartHandler="addCartHandler"
            :markPointData="{ scenepoint: 'ITEMCART', scenedesc: 'recom' }"
          ></product-list>
        </div>
      </Scroller>
      <div style="height: 100%" v-if="nodata && list && list.length <= 0">
        <div
          class="skinTest"
          ref="skinTest"
          style="margin-top: 0.05rem"
          v-if="!advertis && skinTest && $store.state.skinTextCartShow == 1"
        >
          <skinTest :page="'cart'"></skinTest>
        </div>
        <div class="skinTest" style="margin-top: 0.05rem" v-if="advertis">
          <advertisingSpace></advertisingSpace>
        </div>
        <act-coupon></act-coupon>
        <div
          class="couponmsg flex-js-ac"
          v-if="topmsg && (topmsg.type == 2 || topmsg.type == 3)"
          style="width: 100%"
          @click="$router.push('/cashcoupon' + (topmsg.type == 3 ? '?navIndex=1' : ''))"
        >
          <div class="flex-ac">
            <div class="couponImg">
              <img
                class="flex-1"
                :src="topmsg.type == 3 ? topmsg.img_path : '/static/images/coupon@2x.png'"
              />
              <span v-if="topmsg.type == 2" class="f13 color-FC0324">{{ topmsg.couponmoney }}</span>
            </div>
            <div>
              <p class="f13" style="color: #333333; font-weight: bold; margin-bottom: 0.03rem">
                {{ topmsg.message1 }}
              </p>
              <p class="f12" style="color: #6c6c6c">{{ topmsg.message2 }}</p>
            </div>
          </div>
          <div class="f13 flex-ac color-FC0324">
            卡券包
            <van-icon name="arrow" color="#FC0324" />
          </div>
        </div>
        <div
          class="nodata"
          v-if="nodata && productlist && productlist.length > 0"
          ref="nodata"
          style="margin-top: 0.1rem"
        >
          <img src="../../assets/images/nocartd.png" />
          <div class="msg">购物车快饿瘪了T.T</div>
          <div class="gobtn" @click="goList">去逛逛</div>
        </div>
        <div
          class="nodata"
          v-if="nodata && productlist && productlist.length <= 0"
          ref="nodata"
          style="height: calc(86vh); margin-top: 0.1rem"
        >
          <empty :path="'noCart'"></empty>
        </div>
        <div
          style="margin-top: 0.1rem; padding: 0.15rem 0.1rem 0.11rem; background: #fff"
          v-if="list && list.length <= 0 && productlist && productlist.length > 0 && recommend"
        >
          <van-list
            v-model="recLoading"
            :finished="recFinished"
            :immediate-check="false"
            @load="onRecLoad"
          >
            <product-list
              :title="title"
              :productlist="productlist"
              :skuSwitch="'1'"
              @addCartHandler="addCartHandler"
              :markPointData="{ scenepoint: 'ITEMCART', scenedesc: 'recom' }"
            ></product-list>
          </van-list>
        </div>
      </div>
    </div>
    <!--    折上折-->
    <div
      class="additemMsg footerIOS"
      v-if="FlodMsg && discountrule.discountenable == 1 && list && list.length > 0"
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FlodMsg"></div>
      </div>
      <div
        class="btn"
        v-if="parseInt(discountGoodsnum) < parseInt(discountrule.discountlist[0].itemnum)"
        @click="goflod('flod')"
      >
        去凑单>
      </div>
    </div>
    <!--    限时折扣-->
    <div
      class="additemMsg footerIOS"
      v-else-if="
        FlodMsg &&
        fullDiscountRule.discountenable == 1 &&
        fullDiscountRule.switch == 1 &&
        list &&
        list.length > 0
      "
    >
      <div class="pb10 w-100 flex jc-sb ai-c">
        <div class="msg pb0">
          <img src="../../assets/images/surprised.png" />
          <div class="txt" v-html="FlodMsg"></div>
        </div>
        <div class="btn pb0" v-if="fullDiscountEnter == 1" @click="goflod('fulldiscount')">
          去凑单>
        </div>
      </div>
    </div>
    <!--    满赠-->
    <div
      class="additemMsg footerIOS"
      v-else-if="FullGiftMsg && fullgiftrule.actstatus == 1 && list && list.length > 0"
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FullGiftMsg"></div>
      </div>
      <div
        class="btn"
        v-if="parseFloat(currentfullgiftmoney) < parseFloat(fullgiftrule.rulelist[0].allmoney)"
        @click="gofullgift"
      >
        去凑单>
      </div>
    </div>
    <div class="pro_submit footerIOS" v-if="goodsDelShow == false && list && list.length > 0">
      <div class="pro_tools">
        <van-checkbox @click="checkedAll" checked-color="#FC0324" v-model="ischooseAll">
          全选
        </van-checkbox>
        <!--:style="discountrule.discountenable == 1 || fullgiftrule.actstatus == 1 ? {} : {'margin-top': '0.13rem'}"-->
        <div class="pro_total_details">
          <div class="total">
            <div class="totalprice">
              <div class="ppo">
                <div class="totalname">合计:</div>
                <div class="smallprice flex ai-c">
                  <sub>¥</sub>
                  {{ parseFloat(totalmoney).toFixed(2) }}
                </div>
              </div>
              <div class="ppo">
                <div class="oldprice">¥{{ parseFloat(oldtotalmoney).toFixed(2) }}</div>
                <div
                  class="offerdetails"
                  v-if="
                    discountrule.discountenable == 1 ||
                    fullgiftrule.actstatus == 1 ||
                    fullDiscountRule.discountenable == 1 ||
                    birthdayDiscountRule.discountenable == 1 ||
                    morediscountsmoney > 0 ||
                    fullminusmoney > 0
                  "
                  @click="showofferdetails = true"
                >
                  <div class="flp">优惠明细</div>
                  <img src="../../assets/images/upred.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="{
            settlement: true,
            disabled:
              list && list.filter((item) => item.ischoose == true || item.ischoose == 1).length <= 0
          }"
          @click="settlement"
        >
          去结算({{ totalnum }})
        </div>
      </div>
    </div>
    <div class="pro_submit footerIOS" v-if="goodsDelShow == true && list && list.length > 0">
      <div class="pro_tools">
        <van-checkbox v-model="ischooseAll" checked-color="#FC0324" @click="checkedAll">
          全选
        </van-checkbox>
        <div class="choosetxt">已选{{ totalnum }}件</div>
        <div style="flex: 1; -webkit-flex: 1; -moz-flex: 1; -ms-flex: 1; -o-flex: 1">
          <div class="del" @click="del">删除</div>
          <div class="coll" @click="collect">移入收藏夹</div>
        </div>
      </div>
    </div>
    <div class="floatBtn_new" style="bottom: 1.5rem">
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
    </div>
    <footer-comp v-if="isNewPage != -1" :isNewPage="isNewPage" :footerIndex="index" :cartnum="cartnum"></footer-comp>
    <!--:quota-used="5"-->
    <van-sku
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :goods-id="productId"
      :quota="maxNum"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" @click="openPreview" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname == '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span>
              <span class="van-sku__price-num">{{ skuprice }}</span>
              <span v-if="skucostprice" class="van-sku__costprice-symbol">¥</span>
              <span v-if="skucostprice" class="van-sku__costprice-num">{{ skucostprice }}</span>
            </div>
            <!--<i class="van-icon van-icon-clear van-sku__close-icon" @click="showsku = false"></i>-->
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            size="large"
            type="danger"
            class="sure"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked"
          >
            确定
          </van-button>
        </div>
      </template>
    </van-sku>
    <!--新人折扣福利弹窗（与商详逻辑一致：单图无关闭按钮，仅领取后可关闭）-->
    <van-overlay
      :show="ndiscountWelfareShow"
      v-if="ndiscountWelfareShow"
      :close-on-click-overlay="false"
      z-index="99999"
    >
      <div class="wrapper" @click.stop>
        <div class="block" @click.stop>
          <div style="position: relative">
            <img :src="ndiscount_welfare.img" @click="claimNdiscountWelfare" />
          </div>
        </div>
      </div>
    </van-overlay>
    <!--<van-overlay :show="showofferdetails" @click="showofferdetails = false" :z-index="98"/>-->
    <div style="z-index: 2000; position: fixed">
      <van-action-sheet
        v-model="showofferdetails"
        title="优惠明细"
        class="offer"
        close-on-click-overlay
      >
        <div class="offerdetailsdis">
          <div class="ofd1">*实际优惠金额以下单页为准</div>
          <div class="list">
            <div class="item goodstotalprice">
              <div class="tit">商品总额</div>
              <div class="value">¥{{ parseFloat(saletotalmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="fullminusmoney > 0">
              <div class="tit flex-ac">
                全场满减&nbsp;
                <van-tag v-if="fullMinusRules.actLabel" class="tag_danger" type="danger">
                  {{ fullMinusRules.actLabel }}
                </van-tag>
              </div>
              <div class="value">-¥{{ parseFloat(fullminusmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="fullDiscountmoney">
              <div class="tit">{{ fullDiscountRuleTitle }}</div>
              <div class="value">-¥{{ parseFloat(fullDiscountmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="birthdayDiscountmoney">
              <div class="tit">{{ birthdayDiscountRule.actlabel }}</div>
              <div class="value">-¥{{ parseFloat(birthdayDiscountmoney).toFixed(2) }}</div>
            </div>

            <div class="item" v-if="discountrule.discountenable == 1">
              <div class="tit">{{ discountrule.name }}</div>
              <div class="value">-¥{{ parseFloat(discounmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="parseFloat(morediscountsmoney) > 0">
              <div class="tit">多件立减</div>
              <div class="value">-¥{{ parseFloat(morediscountsmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="parseFloat(directReductionmoney) > 0">
              <div class="tit">直降活动</div>
              <div class="value">-¥{{ parseFloat(directReductionmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="presalerule.actstatus == 1">
              <div class="tit">定金翻倍(含定金)</div>
              <div class="value">-¥{{ parseFloat(deposittotalmoney).toFixed(2) }}</div>
            </div>
            <div class="item combined">
              <div class="tit">合计</div>
              <div class="value">¥{{ parseFloat(totalmoney).toFixed(2) }}</div>
            </div>
            <div class="item desc">
              <div class="tit">(未计算运费、现金券、金币，请在下单页查看)</div>
            </div>
          </div>
        </div>
      </van-action-sheet>
    </div>
    <!--活动服务-->
    <div class="presale_info_dialog" v-if="showPresale == true">
      <div class="dialog">
        <div class="header1">
          <div class="van-divider">预售购买</div>
        </div>
        <div class="content">
          {{ presaledescpt }}
        </div>
        <div class="btn" @click="presell">我知道了</div>
      </div>
    </div>
    <!--活动服务-->
    <van-action-sheet v-model="showaction" title="活动介绍">
      <div class="van-action_model">
        <div class="van-item" v-for="(item, index) in msglist" :key="index">
          <div class="tit">
            <van-tag color="#FEE9E6" text-color="#F12A0E">{{ item.actlabel }}</van-tag>
            {{ item.namehide == 1 ? '' : item.name }}
          </div>
          <div class="con" v-if="item.statusmsg">
            {{ item.statusmsg }}
          </div>
          <div class="con" v-html="item.desc.replace(/\n/g, '<br/>')"></div>
        </div>
        <div class="btn">
          <van-button round type="danger" class="vanbtn" @click="showaction = false">
            确定
          </van-button>
        </div>
      </div>
    </van-action-sheet>
    <sku-preview
      v-if="listItem.sku_rule_list"
      hide-price
      hide-add-cart-button
      hide-buy-button
      ref="skuPreview"
      :sku-list="listItem.sku_rule_list"
      @change="changePreview"
    />
  </div>
</template>

<script>
import { Divider, Checkbox, CheckboxGroup, Stepper, Sku, Tag, Overlay } from 'vant'
import {
  fullDiscountRuleHandle,
  birthdayDiscountRuleHandle,
  discountHandle,
  actDescHandle,
  fullDiscountInitData
} from './js/cart'
import productItem from '../common/productItem'
import footerComp from '../common/footerComp'
import skinTest from '../common/skinTest'
import advertisingSpace from '../common/advertisingSpace'
import productList from '../common/productList'
import empty from '../emptypage/empty'
import follow from '../common/follow'
import {
  isWeixin,
  kefu,
  fenxiang,
  cartNum,
  pageStatus,
  download_dialog,
  isWx
} from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
import actCoupon from '../common/coupon'
import skufunc from '../../assets/common/js/sku_func'
import skuPreview from '../common/skuPreview.vue'

export default {
  name: 'cart',
  components: {
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Stepper.name]: Stepper,
    [Sku.name]: Sku,
    [Tag.name]: Tag,
    [Overlay.name]: Overlay,
    productItem,
    footerComp,
    skinTest,
    productList,
    empty,
    Scroller,
    follow,
    actCoupon,
    advertisingSpace,
    skuPreview
  },
  data() {
    return {
      follow: null,
      showaction: false,
      sureGray: false,
      ndiscount_welfare: {}, // 新人折扣福利弹窗配置
      ndiscountWelfareShow: false, // 新人折扣福利弹窗展示标志
      ndiscountWelfareLoading: false, // 新人折扣福利领取防重标志
      msglist: [],
      presaledescpt: '',
      showPresale: false,
      showofferdetails: false,
      currentdiscount: 0,
      discountGoodsnum:0,
      fullDiscountGoodsnum:0,
      FlodMsg: '',
      FullGiftMsg: '',
      discountrule: {},
      fullgiftrule: {},
      presalerule: {},
      halfprice: {},
      ischooseAll: 0,
      checkAll: null /**记录是否是点击全选按钮选中 选中状态 1是 0否 */,
      index: 3,
      value: 1,
      goodsDelShow: false,
      singleChecked: false,
      list: [],
      recommend: false,
      productlist: [],
      recPage: 0,
      recLoading: false,
      recFetching: false,
      recFinished: false,
      cartFinished: false,
      title: '精选好物',
      listItem: {},
      itemIndex: null,
      showsku: false,
      skuname: '',
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      skuprice: '197.00-218.90',
      skucostprice: '',
      productId: null,
      maxNum: null,
      totalmoney: 0,
      oldtotalmoney: 0,
      discounmoney: 0,
      deposittotalmoney: 0,
      currentfullgiftmoney: 0,
      saletotalmoney: 0,
      totalnum: 0,
      isChooseProduct: [],
      skinTest: false,
      advertis: false,
      nodata: false,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            let msg = `数量超出范围~`
            this.$toast(msg)
          }
        },
        handleStepperChange: (currentValue) => {
          this.skuQty = currentValue
          if (this.cartSkuPriceBase) {
            this.skuprice = skufunc.cartUnitPrice(this.cartSkuPriceBase, currentValue).toFixed(2)
          }
        },
        stockNum: 0,
        stockFormatter: (stockNum) => {}
      },
      productNum: 0,
      directReductionmoney: 0 /**直降活动 */,
      fullDiscountRule: {} /**限时折扣 */,
      fullDiscountRuleTitle: '' /**限时折扣-规则标题,单规则取当前规则名称，多规则为“限时折扣” */,
      fullDiscountRuleList: [] /**限时折扣-多规则匹配规则合集 */,
      /**限时折扣-已选商品数量合集匹配多规则限时折扣
       * 数据格式：
       * {
       *  "限时折扣规则编号": 所匹配的已选品数量之和
       * }
       */
      fullDiscountChooseNums: {},
      fullDiscountmoney: 0 /**限时折扣 优惠总金额 */,
      fullDiscountEnter: -1 /**限时折扣 入口显示 */,
      birthdayDiscountRule: {} /**生日折扣 */,
      birthdayDiscountmoney: 0 /**生日折扣 优惠总金额 */,
      cartnum: 0,
      isNewPage: -1,
      topmsg: null,
      morediscountsmoney: 0 /**n件立减 */,
      morediscounts: {} /**n件立减金额 */,
      fullsubtractTotalmoney: 0 /**满减活动 参与满减商品总金额 */,
      fullMinusRules: {} /**满减活动 */,
      fullminusmoney: 0 /**满减优惠金额 */,
      fullMinusMsg: '' /**满减优惠提示 */,
      fullMinus_totalmoney: 0 /**参与满减的总金额 */,
      fixedStyle: {},
      isnewpersontask: 0,
      newpersonjump: '',
      selectedSkuIndex: -1
    }
  },
  mounted: function () {
    var startTime = new Date('2021/02/25 10:00:00').getTime()
    var currTime = new Date().getTime()
    var endTime = new Date('2021/03/03 23:59:59').getTime()
    if (currTime >= startTime && currTime < endTime) {
      this.advertis = true
    } else {
      this.advertis = false
    }
    if (!isWeixin()) {
      if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
        this.$store.commit('SKIN_PATH', 'cart')
        this.$store.commit('PATH_VALUE', '')
      }
    } else {
      fenxiang({ path: 'cart' })
    }
  },
  activated: function () {
    if (this.$store.state.addCartInitData == 1) {
      this.$store.commit('ADD_CART_INIT_DATA', 0)
      this.recommend = false
      this.cartFinished = false
      this.recPage = 0
      this.recFetching = false
      this.recFinished = false
      this.productlist = []
      this.nowPage = 0
      this.onInfinite()
    }
    cartNum((num) => (this.cartnum = num))
    pageStatus((status) => (this.isNewPage = status))
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
    sessionStorage.removeItem('choose_coupon')
    sessionStorage.removeItem('choose_product')
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/' && from.name != 'homePage') {
      /**当前页面刷新不需要切换位置 */
      next((vm) => {
        vm.recommend = false
        vm.nowPage = 0
        vm.getHeadData()
      })
    } else {
      next((vm) => {
        vm.getHeadData()
        if (!isWeixin()) {
          if (vm.waptoken.waptoken && vm.waptoken.waptoken == vm.waptoken.tourists) {
            vm.$store.commit('SKIN_PATH', 'cart')
            vm.$store.commit('PATH_VALUE', '')
          }
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    /**记录离开时的位置 */
    sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    cartSaleText(item) {
      return skufunc.cartUnitPrice(item, item.num).toFixed(2)
    },
    cartHeadText(item) {
      var gray =
        item.isDirectReduction == 1 || item.fullDiscountPrice || item.birthdayDiscountPrice
      if (!gray) return this.cartSaleText(item)
      var extra = parseFloat(item.isDirectReduction == 1 ? item.directReductionPrice : 0)
      var discount =
        (item.fullDiscountPrice &&
          item.birthdayDiscountPrice &&
          item.fullDiscountPrice > item.birthdayDiscountPrice) ||
        !item.birthdayDiscountPrice
          ? parseFloat(item.fullDiscountPrice ? item.fullDiscountPrice : 0)
          : parseFloat(item.birthdayDiscountPrice ? item.birthdayDiscountPrice : 0)
      var price = parseFloat(item.sales_price)
      if (isNaN(price)) price = 0
      if (isNaN(extra)) extra = 0
      if (isNaN(discount)) discount = 0
      return (price + extra + discount).toFixed(2)
    },
    newpersontask() {
      window.location = this.newpersonjump
    },
    fixedFn: function (isFixed) {
      this.fixedStyle = {}
      if (isFixed) this.fixedStyle = { 'margin-top': '0.38rem', padding: '0 0.1rem' }
    },
    getHeadData: function () {
      var urlHead = this.$ajax.getTopMessage_URL
      /**登录校验 */
      this.$customRequestAjax(urlHead).then((res) => {
        if (res.data.code === 200) {
          this.topmsg = res.data ? res.data : null
        }
      })
      this.$newuserFn((data) => {
        if (data.code == 200) {
          this.isnewpersontask = data.isnewpersontask
          this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
        }
      })
    },
    getData: function () {
      var urlShop =
        this.$ajax.getShoppingCart_URL +
        '?fullDiscountRuleNew=1&pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      var that = this
      that.$customRequestAjax(urlShop).then((res) => {
        if (res.data.code == 200) {
          /**新人折扣福利弹窗（与商详一致）：仅首页加载判定，命中即弹，只能领取后关闭 */
          if (that.nowPage == 1) {
            that.ndiscount_welfare = res.data.ndiscount_welfare || {}
            if (that.ndiscount_welfare.show == 1 && that.ndiscount_welfare.img) {
              that.ndiscountWelfareShow = true
            }
          }
          if (that.nowPage == 1) {
            if (res.data.cartlist.length <= 0) {
              that.skinTest = true
              that.nodata = true
            } else {
              that.nodata = false
              res.data.cartlist.map((item) => {
                item.temp_sales_price = item.sales_price
                var indexWh = 0
                var indexDs = 0
                if (item.isdeposit == 1) {
                  item.sku_rule_list.map((itemSon) => {
                    itemSon.temp_sales_price = itemSon.sales_price
                    if (itemSon.canbuycnt <= 0 || itemSon.islimit == 2 || item.is_can_buy == 0) {
                      indexWh++
                    }
                    if (itemSon.islimit == 1) {
                      indexDs++
                    }
                  })
                } else {
                  item.sku_rule_list.map((itemSon) => {
                    itemSon.temp_sales_price = itemSon.sales_price
                    if (
                      itemSon.canbuycnt <= 0 ||
                      itemSon.islimit == 2 ||
                      itemSon.issale == 0 ||
                      item.is_can_buy == 0
                    ) {
                      indexWh++
                    }
                    if (itemSon.islimit == 1) {
                      indexDs++
                    }
                  })
                }
                if (
                  item.sku_rule_list &&
                  item.sku_rule_list.length <= indexWh &&
                  item.sku_rule_list.length > indexDs
                ) {
                  item.inventory = 0 /**无货状态 */
                } else {
                  item.inventory = 1 /**有货状态 */
                }
                if (
                  item.islimit != 0 ||
                  parseInt(item.canbuycnt) <= 0 ||
                  item.issale == 0 ||
                  item.is_can_buy == 0
                ) {
                  item.ischoose = 0
                }
              })
            }
            that.list = res.data.cartlist
            that.refresh = false
          } else {
            res.data.cartlist.map((item) => {
              item.temp_sales_price = item.sales_price
              var indexWh = 0
              var indexDs = 0
              that.customStepperConfig.stockNum = item.canbuycnt
              if (item.isdeposit == 1) {
                item.sku_rule_list.map((itemSon) => {
                  itemSon.temp_sales_price = itemSon.sales_price
                  if (itemSon.canbuycnt <= 0 || itemSon.islimit == 2 || item.is_can_buy == 0) {
                    indexWh++
                  }
                  if (itemSon.islimit == 1) {
                    indexDs++
                  }
                })
              } else {
                item.sku_rule_list.map((itemSon) => {
                  itemSon.temp_sales_price = itemSon.sales_price
                  if (
                    itemSon.canbuycnt <= 0 ||
                    itemSon.islimit == 2 ||
                    itemSon.issale == 0 ||
                    item.is_can_buy == 0
                  ) {
                    indexWh++
                  }
                  if (itemSon.islimit == 1) {
                    indexDs++
                  }
                })
              }
              if (item.sku_rule_list && item.sku_rule_list.length <= indexWh) {
                item.inventory = 0
              } else {
                item.inventory = 1
              }
              if (
                item.islimit != 0 ||
                parseInt(item.canbuycnt) <= 0 ||
                item.issale == 0 ||
                item.is_can_buy == 0
              ) {
                item.ischoose = 0
              }
            })
            that.list = that.list.concat(res.data.cartlist)
          }
          that.discountrule = res.data.discountrule
          that.presalerule = res.data.presalerule
          that.halfprice = {
            halfpricestatus: res.data.halfpricestatus,
            halfpricedesc: res.data.halfpricedesc,
            halfactname: res.data.halfactname,
            halfactlabel: res.data.halfactlabel
          }
          if (res.data.fullMinusRules && Object.keys(res.data.fullMinusRules).length) {
            that.fullMinusRules = res.data.fullMinusRules
          }
          that.presaledescpt = res.data.presaledescpt
          that.fullgiftrule = res.data.fullgiftrule
          that.fullDiscountRule = res.data.fullDiscountRule || {}
          fullDiscountInitData(that)
          that.birthdayDiscountRule = res.data.birthdayDiscountRule || {}
          that.morediscounts = res.data.morediscounts || {}
          that.checkedSingle()
          if (res.data.cartlist.length < that.pagesize) {
            that.cartFinished = true
            that.recommend = true
            // Mod by gaoenhui 2026-09-10 购物车结束后保持 loading，避免 van-list 再触发一次推荐
            if (that.recPage === 0 && !that.recFetching) {
              that.recFinished = false
              that.onRecLoad()
            }
          } else {
            that.loading = false
            that.recommend = false
            that.finished = false
            that.cartFinished = false
          }
        } else if (res.data.code == 10000) {
          that.skinTest = true
          that.nodata = true
          that.cartFinished = true
          that.recommend = true
          if (that.recPage === 0 && !that.recFetching) {
            that.recFinished = false
            that.onRecLoad()
          }
        }
      })
    },
    followFn: function (data) {
      this.follow = data
    },
    addCartHandler: function () {
      this.recommend = false
      this.cartFinished = false
      this.recPage = 0
      this.recFetching = false
      this.recFinished = false
      this.productlist = []
      this.nowPage = 0
      this.onInfinite()
    },
    onRefresh() {
      this.refresh = true
      this.recommend = false
      this.cartFinished = false
      this.recPage = 0
      this.recFetching = false
      this.recFinished = false
      this.productlist = []
      this.nowPage = 1
      this.getData()
    },
    onInfinite() {
      this.loading = true
      if (this.cartFinished) {
        this.onRecLoad()
        return
      }
      this.finished = false
      this.recommend = false
      var that = this
      that.nowPage++
      that.getData()
    },
    onRecLoad: function () {
      if (this.recFinished) {
        this.loading = false
        this.finished = true
        this.recLoading = false
        return
      }
      // van-list 触发 @load 前会先把 recLoading 置 true，不能拿它当请求中标记
      if (this.recFetching) {
        return
      }
      var that = this
      that.recFetching = true
      that.recLoading = true
      that.recPage++
      var url =
        that.$ajax.getRecommendByShoppingCart_URL +
        '?pageno=' +
        that.recPage +
        '&pagesize=' +
        that.pagesize
      that.$customRequestAjax(url).then((res) => {
        that.recFetching = false
        that.recLoading = false
        that.loading = false
        if (res.data.code == 200) {
          var list = res.data.itemlist || []
          if (that.recPage === 1) {
            that.productlist = list
          } else {
            that.productlist = that.productlist.concat(list)
          }
          if (list.length < that.pagesize) {
            that.recFinished = true
            that.finished = true
          } else {
            that.recFinished = false
            that.finished = false
          }
        } else {
          that.recFinished = true
          that.finished = true
        }
      })
    },
    stepperFn(items) {
      var that = this
      if (items.num < 0) items.num = Math.abs(items.num)
      setTimeout(function () {
        if (!that.goodsDelShow) {
          that.fullDiscountRuleFn()
          that.birthdayDiscountRuleFn()
          that.totalMoney()
        }
      })
    },
    goList() {
      this.$router.push('/classification')
    },
    changeEdit() {
      this.goodsDelShow = !this.goodsDelShow
      let list = null
      var that = this
      if (!this.goodsDelShow) {
        var noAllIndex = 0
        var allIndex = 0
        list = that.list.map(function (item, i) {
          if (
            item.isdeposit == 0 &&
            (item.islimit != 0 ||
              item.issale == 0 ||
              parseInt(item.canbuycnt) <= 0 ||
              item.is_can_buy == 0)
          ) {
            item.ischoose = false
            noAllIndex++
          } else if (
            item.isdeposit == 1 &&
            (item.finalpaystatus == 0 ||
              item.islimit != 0 ||
              parseInt(item.canbuycnt) <= 0 ||
              item.is_can_buy == 0)
          ) {
            item.ischoose = false
            noAllIndex++
          } else {
            if (that.ischooseAll && item.isdeposit == 1 && item.finalpaystatus == 1) {
              item.ischoose = true
            }
            if (item.ischoose) {
              allIndex++
            }
          }
          return item
        })
        if (list.length > noAllIndex && list.length - noAllIndex <= allIndex) {
          that.ischooseAll = true
        } else {
          that.ischooseAll = false
        }
        this.list = list
      } else {
        var noAllIndex = 0
        var allIndex = 0
        list = that.list.map(function (item, i) {
          if (
            item.islimit != 0 ||
            item.issale == 0 ||
            parseInt(item.canbuycnt) <= 0 ||
            item.issale == 0 ||
            item.is_can_buy == 0
          ) {
            if (that.ischooseAll) {
              item.ischoose = true
            }
          }
          if (item.isdeposit == 1) {
            item.ischoose = false
            noAllIndex++
          } else {
            if (item.ischoose) {
              allIndex++
            }
          }
          return item
        })
        if (list.length > noAllIndex && list.length - noAllIndex <= allIndex) {
          that.ischooseAll = true
        } else {
          that.ischooseAll = false
        }
        this.list = list
      }
    },
    presell() {
      this.showPresale = false
      this.settlement()
    },
    settlement() {
      var that = this
      var shopConfirmResult = {
        skuidArr: [],
        itemNum: [],
        skuidArrOversea: [],
        from: 1,
        orderfrom: 0,
        itemNumOversea: [],
        totalmoney:
          that.totalmoney +
          that.discounmoney +
          that.fullDiscountmoney +
          that.birthdayDiscountmoney +
          that.morediscountsmoney +
          that.fullminusmoney,
        totalnum: 0,
        liveId: [],
        roomId: [],
        LiveIdArrOversea: [],
        roomIdArrOversea: [],
        course_params: []
      }
      if (
        !(
          this.list &&
          this.list.filter((item) => item.ischoose == true || item.ischoose == 1).length <= 0
        )
      ) {
        var ispresale = 0
        that.isChooseProduct.forEach(function (item) {
          if (item.courseid) shopConfirmResult.course_params.push(item.skuid + '_' + item.courseid)

          if (item.isoversea == 1) {
            shopConfirmResult.skuidArrOversea.push(item.skuid)
            shopConfirmResult.itemNumOversea.push(item.num)
            shopConfirmResult.LiveIdArrOversea.push(item.live_id)
            shopConfirmResult.roomIdArrOversea.push(item.room_id)
          } else {
            shopConfirmResult.skuidArr.push(item.skuid)
            shopConfirmResult.itemNum.push(item.num)
            shopConfirmResult.liveId.push(item.live_id)
            shopConfirmResult.roomId.push(item.room_id)
          }
          shopConfirmResult.totalnum += +item.num
          if (item.ispresale == 1) {
            ispresale = 1
          }
        })
        if (
          this.showPresale == false &&
          ispresale == 1 &&
          !localStorage.getItem('itemcartpresale')
        ) {
          that.showPresale = true
          localStorage.setItem('itemcartpresale', '1')
        } else {
          var urlCheck
          if (
            shopConfirmResult.skuidArr.length > 0 &&
            shopConfirmResult.skuidArrOversea.length <= 0
          ) {
            urlCheck =
              that.$ajax.checkOrder_URL +
              '?skuids=' +
              shopConfirmResult.skuidArr.join() +
              '&buynum=' +
              shopConfirmResult.itemNum.join()
            that.$customRequestAjax(urlCheck).then((res) => {
              if (res.data.code == 200) {
                if (res.data.vipLevelLimitMsg) {
                  that.$dialog
                    .confirm({
                      message: res.data.vipLevelLimitMsg,
                      className: 'collect_button_alert',
                      cancelButtonColor: '#FC0324',
                      cancelButtonText: '取消',
                      confirmButtonColor: '#FFFCFC',
                      confirmButtonText: '去查看'
                    })
                    .then(() => {
                      // on close
                      that.$app.argLink({ path: '/vipcenter' })
                    })
                  return
                }
                localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
                sessionStorage.removeItem('choose_integral')
                sessionStorage.removeItem('choose_coupon')
                sessionStorage.removeItem('choose_product')
                sessionStorage.removeItem('oversea_List')
                /**埋点 */
                that.dataCollection()
                that.$router.push('/order')
              } else {
                that.nowPage = 0
                that.onInfinite()
              }
            })
          } else if (
            shopConfirmResult.skuidArrOversea.length > 0 &&
            shopConfirmResult.skuidArr.length <= 0
          ) {
            /**为了使普通商品和海外商品的确认订单接口参数key值保持一致 */
            shopConfirmResult.skuidArr = shopConfirmResult.skuidArrOversea
            shopConfirmResult.itemNum = shopConfirmResult.itemNumOversea
            shopConfirmResult.liveId = shopConfirmResult.LiveIdArrOversea
            shopConfirmResult.roomId = shopConfirmResult.roomIdArrOversea
            shopConfirmResult.skuidArrOversea = []
            shopConfirmResult.itemNumOversea = []
            shopConfirmResult.LiveIdArrOversea = []
            shopConfirmResult.roomIdArrOversea = []
            if (isWx != 3) {
              /**wap端可支付宝支付海外商品 */
              download_dialog(that)
              return
            }
            urlCheck =
              that.$ajax.checkOrder_URL +
              '?skuids=' +
              shopConfirmResult.skuidArr.join() +
              '&buynum=' +
              shopConfirmResult.itemNum.join()
            that.$customRequestAjax(urlCheck).then((res) => {
              if (res.data.code == 200) {
                if (res.data.vipLevelLimitMsg) {
                  that.$dialog
                    .confirm({
                      message: res.data.vipLevelLimitMsg,
                      className: 'collect_button_alert',
                      cancelButtonColor: '#FC0324',
                      cancelButtonText: '取消',
                      confirmButtonColor: '#FFFCFC',
                      confirmButtonText: '去查看'
                    })
                    .then(() => {
                      // on close
                      that.$app.argLink({ path: '/vipcenter' })
                    })
                  return
                }
                localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
                sessionStorage.removeItem('choose_integral')
                sessionStorage.removeItem('choose_coupon')
                sessionStorage.removeItem('choose_product')
                sessionStorage.removeItem('oversea_List')
                /**埋点 */
                that.dataCollection()
                that.$router.push('/order')
              } else {
                that.onRefresh()
              }
            })
          } else {
            that.$toast('海外商品不能与普通商品一起购买')
          }
        }
      }
    },
    dataCollection() {
      let list = this.isChooseProduct
      for (let i in list) {
        let params = {
          productId_var: list[i].itemid /**商品id */,
          productName_var: list[i].name /**商品名称 */,
          firstCat_var: '' /**商品一级分类 */,
          productType_var: '' /**商品品类 */,
          productFormat_var: list[i].skuid /**商品规格 */,
          buyQuantity_var: list[i].num /**购买数量 */,
          payAmount_var: (list[i].sales_price * list[i].num).toFixed(2) /**支付金额 */
        }
        gio('track', 'settleProduct', params)
      }
    },
    del() {
      var urlDel = this.$ajax.delShoppingCart_URL
      var that = this
      var deleteProduct = {
        skuIds: [],
        skuIndex: []
      }
      deleteProduct.skuIds = []
      deleteProduct.skuIndex = []
      this.list.map(function (item, index) {
        if (item.ischoose) {
          deleteProduct.skuIds.push(item.skuid)
          deleteProduct.skuIndex.unshift(index)
        }
      })
      var data = {
        skuids: deleteProduct.skuIds.join()
      }
      if (deleteProduct.skuIds && deleteProduct.skuIds.length > 0) {
        that.$dialog
          .confirm({
            message: '你确认将这' + deleteProduct.skuIds.length + '个宝贝删除？',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            cancelButtonText: '我再想想',
            confirmButtonText: '删除'
          })
          .then(() => {
            that.$customRequestAjax.post(urlDel, data).then((res) => {
              if (res.data.code == 200) {
                deleteProduct.skuIndex.map(function (item, index) {
                  that.list.splice(item, 1)
                })
                if (that.list.length <= 0) {
                  that.nowPage = 0
                  that.list = []
                  that.onInfinite()
                }
              }
            })
          })
          .catch(() => {})
      } else {
        this.$toast('请选择商品')
      }
    },
    collect() {
      var urlColl = this.$ajax.addCollection_URL
      var product = {
        skuIds: [],
        skuIndex: [],
        itemId: []
      }
      product.skuIds = []
      product.skuIndex = []
      this.list.map(function (item, index) {
        if (item.ischoose) {
          product.skuIds.push(item.skuid)
          product.itemId.push(item.itemid)
          product.skuIndex.unshift(index)
        }
      })
      var dataColl = {
        itemids: product.itemId.join()
      }
      if (product.itemId && product.itemId.length > 0) {
        this.$customRequestAjax.post(urlColl, dataColl).then((res) => {
          if (res.data.code == 200) {
            this.$toast('收藏成功')
          }
        })
      } else {
        this.$toast('请选择商品')
      }
    },
    checkedAll() {
      let that = this
      that.checkAll = 1
      let list = null
      if (that.goodsDelShow) {
        list = this.list.map(function (item, i) {
          if (item.isdeposit == 0) {
            item.ischoose = that.ischooseAll
          }
          return item
        })
      } else if (!that.goodsDelShow) {
        list = that.list.map(function (item, i) {
          if (item.isdeposit == 0) {
            if (
              item.islimit == 0 &&
              item.issale == 1 &&
              parseInt(item.canbuycnt) > 0 &&
              item.issale != 0 &&
              item.is_can_buy != 0
            ) {
              item.ischoose = that.ischooseAll
            }
          } else {
            if (
              item.finalpaystatus == 1 &&
              item.islimit == 0 &&
              parseInt(item.canbuycnt) > 0 &&
              item.is_can_buy != 0
            ) {
              item.ischoose = that.ischooseAll
            }
          }
          return item
        })
      }
      this.list = list
      var datas = {
        isall: 1,
        ischoose: this.ischooseAll ? 1 : 0
      }
      this.updateProduct(datas)
    },
    checkedSingle() {
      let list = this.list.filter((item) => item.ischoose == true || item.ischoose == 1)
      var stocklist
      if (this.goodsDelShow) {
        stocklist = this.list.filter((item, index) => item.isdeposit == 0)
      } else if (!this.goodsDelShow) {
        stocklist = this.list.filter((item, index) =>
          item.isdeposit == 0
            ? item.islimit == 0 &&
              item.issale == 1 &&
              parseInt(item.canbuycnt) > 0 &&
              item.issale != 0 &&
              item.is_can_buy != 0
            : item.finalpaystatus == 1 &&
              item.islimit == 0 &&
              parseInt(item.canbuycnt) > 0 &&
              item.is_can_buy != 0
        )
      }
      if (list.length >= stocklist.length && stocklist.length > 0) {
        this.ischooseAll = 1
      } else {
        this.ischooseAll = 0
      }
      this.isChooseProduct = this.list.filter((item) => item.ischoose == true || item.ischoose == 1)
      this.totalnum = 0
      this.totalnum = this.isChooseProduct.length
      this.fullDiscountRuleFn()
      this.birthdayDiscountRuleFn()
      this.totalMoney()
    },
    checkedSingleFn(items) {
      var datas = {
        skuid: items.skuid,
        num: items.num,
        new_skuid: items.skuid,
        ischoose: items.ischoose ? 1 : 0,
        isall: this.ischooseAll ? 1 : 0
      }
      if (
        items.inventory != 0 &&
        items.islimit == 0 &&
        parseInt(items.canbuycnt) > 0 &&
        items.issale != 0 &&
        items.is_can_buy != 0
      ) {
        this.updateProduct(datas)
      }
    },
    /**限时折扣 */
    fullDiscountRuleFn: function () {
      fullDiscountRuleHandle(this)
    },
    /**生日折扣 */
    birthdayDiscountRuleFn: function () {
      birthdayDiscountRuleHandle(this)
    },
    // 新人折扣福利弹窗-领取（与商详一致：防重+loading；成功/失败均 toast 后关闭弹窗）
    claimNdiscountWelfare() {
      if (this.ndiscount_welfare.clicktype != 'claim' || this.ndiscountWelfareLoading) return
      this.ndiscountWelfareLoading = true
      this.$toast.loading({ duration: 0, message: '领取中...', forbidClick: true })
      this.$customRequestAjax
        .get(this.$ajax.claimWelfare_URL, {})
        .then((res) => {
          this.ndiscountWelfareLoading = false
          this.$toast.clear()
          if (res.data.code == 200) {
            this.$toast(res.data.msg || '领取成功')
          } else {
            this.$toast(res.data.msg || '领取失败')
          }
          this.closeNdiscountWelfare()
        })
        .catch(() => {
          this.ndiscountWelfareLoading = false
          this.$toast.clear()
          this.$toast('网络异常，请稍后重试')
          this.closeNdiscountWelfare()
        })
    },
    // 新人折扣福利弹窗-关闭（购物车无弹窗链，直接释放）
    closeNdiscountWelfare() {
      this.ndiscountWelfareShow = false
    },
    updateProduct: function (data, fn) {
      var urlSku = this.$ajax.updateShoppingCart_URL
      this.$customRequestAjax.post(urlSku, data).then((res) => {
        if (res.data.code == 200) {
          if (typeof fn == 'function') {
            fn()
          }
        }
      })
    },
    openPreview() {
      this.$refs.skuPreview.showPreview(this.selectedSkuIndex)
      skufunc.selectedSkuHandle(this.selectedSkuIndex, this)
    },
    changePreview(index) {
      skufunc.selectedSkuHandle(index, this)
    },
    openSku(item, index) {
      skufunc.openSku_cart(item, index, this)
    },
    checkedSku(skuValue) {
      skufunc.checkedSku_cart(skuValue, this)
    },
    onConfirmClicked() {
      skufunc.onConfirmClicked_cart(this)
    },
    num: function (items) {
      var that = this
      setTimeout(function () {
        that.fullDiscountRuleFn()
        that.birthdayDiscountRuleFn()
        that.totalMoney()
        var datas = {
          skuid: items.skuid,
          num: items.num,
          new_skuid: ''
        }
        that.updateProduct(datas)
      })
    },
    overlimit: function (items) {
      if (items.num >= items.canbuycnt) {
        this.$toast('数量超出范围~')
      }
    },
    totalMoney: function () {
      var that = this
      that.totalmoney = 0
      that.oldtotalmoney = 0
      that.discounmoney = 0
      that.currentfullgiftmoney = 0
      that.currentdiscount = 0
      that.saletotalmoney = 0
      that.FlodMsg = ''
      that.FullGiftMsg = ''
      that.discountGoodsnum = 0
      that.fullDiscountGoodsnum = 0
      that.deposittotalmoney = 0
      that.directReductionmoney = 0
      that.morediscountsmoney = 0
      that.fullMinus_totalmoney = 0
      let money = 0,
        discountlist = [],
        discount_rule = {},
        fullMinus_totalmoney = 0
      that.isChooseProduct.forEach(function (item) {
        if (!item.num) return
        let morediscountsmoney = 0
        if (item.ismorediscounts && item.num >= item.morediscountsitemnum) {
          if (item.issuperposition != 0) {
            morediscountsmoney =
              parseFloat(item.morediscountsmoney) * parseInt(item.num / item.morediscountsitemnum)
          } else {
            morediscountsmoney = parseFloat(item.morediscountsmoney)
          }
        }
        that.morediscountsmoney += morediscountsmoney
        that.totalmoney =
          that.totalmoney + parseFloat(item.sales_price) * parseInt(item.num) - morediscountsmoney
        if (item.isdeposit == 1) {
          that.deposittotalmoney += parseFloat(item.depositmoney)
          that.saletotalmoney +=
            (parseFloat(item.sales_price) + parseFloat(item.depositmoney)) * parseInt(item.num)
        } else {
          that.saletotalmoney += parseFloat(item.sales_price) * parseInt(item.num)
        }
        that.oldtotalmoney = that.oldtotalmoney + parseFloat(item.cost_price) * parseInt(item.num)
        if (item.isdiscount == 1 || item.isFullDiscount == 1) {
          if (item.isFullDiscount == 1) that.fullDiscountGoodsnum += parseInt(item.num)
          if (item.isdiscount == 1) that.discountGoodsnum += parseInt(item.num)
          if (item.isdiscount == 1) money += parseFloat(item.sales_price) * parseInt(item.num)
        }
        if (item.fullMonusRules && item.fullMonusRules.isfullMinus == 1) {
          fullMinus_totalmoney +=
            (parseFloat(item.sales_price) +
              parseFloat(item.fullDiscountPrice || item.birthdayDiscountPrice || 0)) *
            parseInt(item.num)
        }
        if (item.isDirectReduction && item.isDirectReduction == 1) {
          that.saletotalmoney += parseFloat(item.directReductionPrice) * item.num
          that.directReductionmoney += parseFloat(item.directReductionPrice) * item.num
        }
      })
      that.fullMinus_totalmoney = fullMinus_totalmoney
      that.saletotalmoney += that.fullDiscountmoney + that.birthdayDiscountmoney
      discountHandle(that, { discountlist, discount_rule })

      if (money > 0 && that.currentdiscount > 0) {
        that.discounmoney = money * (1 - that.currentdiscount)
        that.totalmoney -= that.discounmoney
      }
    },
    productFn: function (items) {
      this.$clickburiedPoint({
        url: 'ckysdatacenter/itemclick/save',
        data: {
          itemid: items.itemid,
          scenepoint: 'ITEMCART'
        }
      })
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: items.itemid,
          live_id: items.live_id
        }
      })
    },
    /**客服 */
    keFu: function () {
      /**登录校验 */
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: ''
            }
          })
        } else {
          kefu()
        }
      } else {
        kefu()
      }
    },
    goflod: function (type) {
      window.location = '/static/wx/html/20190820/Flod/flodlist.html?acttype=' + type
    },
    gofullgift: function () {
      var url =
        '/static/wx/html/fullGift/index.html?currentfullgiftmoney=' +
        this.currentfullgiftmoney +
        '&currentdiscount=' +
        this.currentdiscount
      var skuids = [],
        nums = []
      this.isChooseProduct.map((item) => {
        skuids.push(item.skuid)
        nums.push(item.num)
      })
      url += '&skuids=' + skuids.join() + '&nums=' + nums.join()
      window.location = url
    },
    gofullsubtract: function () {
      window.location.href = '/static/wx/html/20190820/Flod/fullsubtract.html?acttype=fullsubtract'
    },
    showActDesc: function (obj) {
      actDescHandle(this, { obj })
      this.showaction = true
    },
    dateFn: function (date, type) {
      if (!date) return
      var arr = date.split(' ')
      var arrDateTime = arr[1].split(':')
      var arrDate = arr[0].split('-')
      if (type == 'datetime') {
        return (
          '<span><i>' +
          parseInt(arrDate[0]) +
          '</i> 年 <i>' +
          parseInt(arrDate[1]) +
          '</i> 月 <i>' +
          parseInt(arrDate[2]) +
          '</i> 日 ' +
          arrDateTime[0] +
          ':' +
          arrDateTime[1] +
          '</span>'
        )
      } else if (type == 'datetimestr') {
        return (
          parseInt(arrDate[1]) +
          '月' +
          parseInt(arrDate[2]) +
          '日' +
          arrDateTime[0] +
          ':' +
          arrDateTime[1]
        )
      } else if (type == 'datestr') {
        return (
          parseInt(arrDate[0]) + '年' + parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日'
        )
      } else {
        return (
          '<span><i>' +
          parseInt(arrDate[0]) +
          '</i> 年 <i>' +
          parseInt(arrDate[1]) +
          '</i> 月 <i>' +
          parseInt(arrDate[2]) +
          '</i> 日</span>'
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './css/cart_scoped.scss';
</style>
<style lang="scss">
@import './css/cart.scss';
</style>



// WEBPACK FOOTER //
// src/components/shopcart/cart.vue